/**
 * Auto-capitalise the first letter of every word in a string.
 * Letters mid-word are left untouched (user typed them deliberately).
 * Whitespace is treated as the word separator; Unicode-aware so diacritics
 * in customer / address names round-trip cleanly.
 *
 * Bypass keys (handled in the Input / Textarea wrappers, not here):
 *   • **Shift**   — one-shot: the current keystroke is skipped
 *   • **CapsLock** — persistent: the browser already produces uppercase
 *                    characters, so we skip re-transforming
 */
export function capitalizeWords(value) {
  if (!value) return value;
  return value.replace(/(^|\s)(\p{L})/gu, (_m, sep, ch) => sep + ch.toUpperCase());
}

/**
 * The set of HTML input `type` values where auto-capitalisation makes
 * sense. Everything else — email, password, number, url, tel, date,
 * search, colour, file, … — is deliberately excluded so the transform
 * never mangles login emails, GSTIN case toggles, OTP codes, dates, etc.
 */
export const TEXTUAL_INPUT_TYPES = new Set([
  "text",
  "",         // <input> without a type attribute defaults to "text"
]);
